/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';


const Home=()=>import('../src/components/Home');


const Contract = () => import('../src/Auto/Contract');
const ContractPreview = () => import('../src/Auto/ContractPreview');
const MonitoringForm = () => import('../src/Auto/MonitoringForm');
const Monitoring = () => import('../src/Auto/components/Monitoring');
const ImportantConditions = () => import('../src/Auto/ImportantConditions');


Vue.use(Router);

const router = new  Router({
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'open active',
    scrollBehavior: () => ({y: 0}),
    routes: [
        {
            path: '',
            name: 'Home',
            component: Home,

        },
        {
            path: '/auto/contract/:id/:cust',
            name: 'Contract',
            component: Contract,
        },
        {
            path: '/auto/ContractPreview/:id/:cust',
            name: 'ContractPreview',
            component: ContractPreview,
        },
        {
            path: '/auto/MonitoringForm',
            name: 'MonitoringForm',
            component: MonitoringForm,
        },
        {
            path: '/auto/Monitoring/:cust/:form?',
            name: 'Monitoring',
            component: Monitoring,
        },
        {
            path: '/auto/ImportantConditions/:policy/:start/:end/:cust',
            name: 'ImportantConditions',
            component: ImportantConditions,
        },
        {
            path: '/tpl/contract/:id/:cust',
            name: 'ContractTpl',
            component: () => import('../src/Auto/ContractTpl'),
        },
        {
            path: '/Dev/tpl/contract/:id/:cust',
            name: 'ContractTplDev',
            component: () => import('../src/Auto/ContractTplDev'),
        },
        {
            path: '/tpl/ImportantConditions/:policy/:start/:end/:cust',
            name: 'ImportantConditionsTpl',
            component: () => import('../src/Auto/ImportantConditionsTpl'),
        },
        {
            path: '/tpl/ImportantConditions/:policy/:start/:end/:cust',
            name: 'ImportantConditionsTpl',
            component: () => import('../src/Auto/ImportantConditionsTpl'),
        },
        {
            path: '/vitamin/contract/:cont/:cust',
            name: 'Contract',
            component: ()=>import('../src/Medical/Contract'),
        },
        {
            path: '/vitamin/ContractPreview/:cont/:cust',
            name: 'ContractPreview',
            component: ()=>import('../src/Medical/ContractPreview'),
        },
        {
            path: '/vitamin/MonitoringForm',
            name: 'MonitoringForm',
            component: ()=>import('../src/Medical/MonitoringForm'),
        },
        {
            path: '/vitamin/Monitoring/:cust/:form?',
            name: 'Monitoring',
            component: ()=>import('../src/Medical/components/Monitoring'),
        },
        {
            path: '/vitamin/ImportantConditions/:policy/:start/:end/:policyid/:cont/:cust',
            name: 'ImportantConditions',
            component: () => import('../src/Medical/ImportantConditions'),
        },
        //{
        //    path: '/CRV/contract/:cont/:cust',
        //    name: 'ContractCrv',
        //    component: () => import('../src/CRV/Contract'),
        //},
        //{
        //    path: '/CRV/ImportantConditions/:policy/:start/:end/:policyid/:cont/:cust',
        //    name: 'ImportantConditionsCrv',
        //    component: () => import('../src/CRV/ImportantConditions'),
        //},
        {
            path: '/Pro/ContractPreview/:cont/:cust/:rowid',
            name: 'ContractPreview',
            component: () => import('../src/Procredit/ContractPreview'),
        },
        {
            path: '/Pro/Contract/:cont/:cust/:role',
            name: 'Contract',
            component: () => import('../src/Procredit/Contract'),
        },
        {
            path: '/Pro/ContractGenerate/:cont/:cust/:role',
            name: 'ContractGenerate',
            component: () => import('../src/Procredit/ContractGenerate'),
        },
        {
            path: '/Pro/ContractPreviewOwner',
            name: 'ContractPreviewOwner',
            component: () => import('../src/Procredit/OwnerContractPreview'),
        },
        {
            path: '/PcbMain/ContractPreview/:cont/:cust/:rowid?',
            name: 'ContractPreview2',
            component: () => import('../src/Pcb/ContractPreview'),
        },
        {
            path: '/Pcb/ContractPreview/:cont/:cust/:rowid?',
            name: 'ContractPreview',
            component: () => import('../src/Pcb/ContractPreview'),
        },
        {
            path: '/Pcb/Contract/:cont/:cust/:role',
            name: 'Contract',
            component: () => import('../src/Pcb/Contract'),
        },
        {
            path: '/Pcb/ContractGenerate/:cont/:cust/:role',
            name: 'ContractGenerate',
            component: () => import('../src/Pcb/ContractGenerate'),
        },
        {
            path: '/policies/CASCO/:cust/:rowid',
            name: 'CascoPolice',
            component: () => import('../src/CredoCorpAuto/CascoPolicy'),
        },
        // otherwise redirect to home
        {path: '*', redirect: '/'}
    ]
});

export default router